// Validation utilities
export const validation = {
  // Email validation
  email: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },

  // Phone validation (Kenyan format)
  phone: (phone) => {
    const phoneRegex = /^(\+254|254|0)?[17]\d{8}$/;
    return phoneRegex.test(phone.replace(/\s/g, ''));
  },

  // Required field validation
  required: (value) => {
    return value && value.trim().length > 0;
  },

  // Name validation
  name: (name) => {
    const nameRegex = /^[a-zA-Z\s]{2,50}$/;
    return nameRegex.test(name.trim());
  },

  // Address validation
  address: (address) => {
    return address && address.trim().length >= 5;
  },

  // Validate checkout form
  // Everything the Review step (checkout step 1) actually collects.
  // Factored out so it can gate "Continue to payment" on its own — it used
  // to be unvalidated entirely, since validateCheckoutForm below (which
  // also checks paymentMethod, a step-2-only field) was only ever run at
  // final payment submit, by which point the user is no longer looking at
  // the fields it might be complaining about.
  validateCheckoutStep1: (formData) => {
    const errors = {};

    // Personal Information
    if (!validation.required(formData.fullName)) {
      errors.fullName = 'Full name is required';
    } else if (!validation.name(formData.fullName)) {
      errors.fullName = 'Please enter a valid name (2-50 characters, letters only)';
    }

    if (!validation.required(formData.email)) {
      errors.email = 'Email is required';
    } else if (!validation.email(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!validation.required(formData.phone)) {
      errors.phone = 'Phone number is required';
    } else if (!validation.phone(formData.phone)) {
      errors.phone = 'Please enter a valid Kenyan phone number';
    }

    // Shipping Information
    if (!validation.required(formData.address)) {
      errors.address = 'Address is required';
    } else if (!validation.address(formData.address)) {
      errors.address = 'Please enter a complete address (minimum 5 characters)';
    }

    if (!validation.required(formData.city)) {
      errors.city = 'City is required';
    }

    if (!validation.required(formData.country)) {
      errors.country = 'Country is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Full checkout form, run at final payment submit — step 1's checks plus
  // paymentMethod (only ever set on step 2, so it can't gate step 1 itself).
  validateCheckoutForm: (formData) => {
    const step1Result = validation.validateCheckoutStep1(formData);
    const errors = { ...step1Result.errors };

    if (!validation.required(formData.paymentMethod)) {
      errors.paymentMethod = 'Payment method is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  },

  // Validate contact form
  validateContactForm: (formData) => {
    const errors = {};

    if (!validation.required(formData.name)) {
      errors.name = 'Name is required';
    } else if (!validation.name(formData.name)) {
      errors.name = 'Please enter a valid name';
    }

    if (!validation.required(formData.email)) {
      errors.email = 'Email is required';
    } else if (!validation.email(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    if (!validation.required(formData.message)) {
      errors.message = 'Message is required';
    } else if (formData.message.trim().length < 10) {
      errors.message = 'Message must be at least 10 characters long';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};

